var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 7.10002V3.31669C21.8333 2.14169 21.3 1.66669 19.975 1.66669H16.6083C15.2833 1.66669 14.75 2.14169 14.75 3.31669V7.09169C14.75 8.27502 15.2833 8.74169 16.6083 8.74169H19.975C21.3 8.75002 21.8333 8.27502 21.8333 7.10002Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 16.475V13.1083C17.8333 11.7833 17.3 11.25 15.975 11.25H12.6083C11.2833 11.25 10.75 11.7833 10.75 13.1083V16.475C10.75 17.8 11.2833 18.3333 12.6083 18.3333H15.975C17.3 18.3333 17.8333 17.8 17.8333 16.475Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 7.10002V3.31669C12.2501 2.14169 11.7167 1.66669 10.3917 1.66669H7.02508C5.70008 1.66669 5.16675 2.14169 5.16675 3.31669V7.09169C5.16675 8.27502 5.70008 8.74169 7.02508 8.74169H10.3917C11.7167 8.75002 12.2501 8.27502 12.2501 7.10002Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25008 16.475V13.1083C8.25008 11.7833 7.71675 11.25 6.39175 11.25H3.02508C1.70008 11.25 1.16675 11.7833 1.16675 13.1083V16.475C1.16675 17.8 1.70008 18.3333 3.02508 18.3333H6.39175C7.71675 18.3333 8.25008 17.8 8.25008 16.475Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternB);
export default __webpack_public_path__ + "static/media/pattern-b.78c4846f99206b5f5204d4317e7f0b65.svg";
export { ForwardRef as ReactComponent };